module.exports = __webpack_public_path__ + "static/img/1088_big.b9d525a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1088_big.png
// module id = p4Yi
// module chunks = 1